<template>
    <v-layout
      mt-3
      wrap
    >
      <v-flex v-if="habilitacaoOrganizacaoGetter.st_habilitacao != -1">

        <v-flex mt-2>
          <v-flex
            title
            text--secondary
            mb-3
          >
            Análise da Habilitação
          </v-flex>
            <v-layout
              column
              wrap
              justify-center
            >
              <v-flex
                v-for="item in habilitacaoOrganizacao.organizacao.arquivos"
                :key="item.arquivo.co_arquivo"
                md6
              >
                <v-card
                  v-if="item.arquivo.co_arquivo && item.tp_arquivo != 'representante_foto_rosto'"
                  min-height="55"
                  class="elevation-1"
                >
                  <v-layout>
                    <v-flex>
                      <v-flex title text--secondary mt-3 ml-4 >
                          {{ descricaoArquivos[item.tp_arquivo] }}
                      </v-flex>
                    </v-flex>
                    <v-flex
                      xs3
                      sm1
                      mt-2 mr-2 
                    >
                      <v-icon
                        large
                        color="blue darken-3"
                        @click="downloadArquivo(item.arquivo.co_arquivo)"
                      >
                        cloud_download
                      </v-icon>
                    </v-flex>
                  </v-layout>
                  <v-flex
                    class="pa-1"
                    ml-4
                  >
                    <v-radio-group
                      v-model="item.arquivo.situacaoArquivo.st_situacao"
                      row
                      disabled
                    >
                      <v-radio
                        label="Regular"
                        class="v-label"
                        value="REGULAR"
                      />
                      <v-radio
                        label="Irregular"
                        class="v-label"
                        value="IRREGULAR"
                      />
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    v-if="item.arquivo.situacaoArquivo.st_situacao === 'IRREGULAR'"
                    pa-3
                  >
                    <v-textarea
                      v-model="item.arquivo.situacaoArquivo.ds_avaliacao"
                      box
                      label="Observação"
                      name="input-7-4"
                      rows="5"
                      row-height="20"
                      no-resize
                      disabled
                    />
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>

        <v-flex
            title
            text--secondary
            mt-3
          >
            Anexos do Parecer
          </v-flex>
        <v-layout
              row
              wrap
              justify-start
            >
              <v-flex
                v-for="certidao in habilitacaoOrganizacao.certidoes"
                :key="certidao.co_arquivo"
                md4
                pt-3
              >
                  <v-btn color="blue-grey" outline @click="downloadArquivo(certidao.co_arquivo)">
                    {{certidoes.find(c=> c.tp_arquivo == certidao.tp_arquivo).label}}
                    <v-icon
                      right
                      dark
                    >
                    cloud_download
                    </v-icon>
                  </v-btn>     
              </v-flex>
              
            </v-layout>
        <v-flex
          mt-4
        >
          <v-layout>
            <v-flex
              xs6
              sm6
              md6
              lg6
              pr-1
            >
            <v-select
              v-model="habilitacaoOrganizacao.st_habilitacao"
              :items="organizacaoUtils.opcoesStatusHabilitacao"
              label="*Resultado da Habilitação"
              item-value="st_habilitacao"
              item-text="ds_habilitacao"
              disabled
            />
            </v-flex>
            <v-flex
              xs6
              sm6
              md6
              lg6
              pl-1
            >
            <v-text-field
                      :value="habilitacaoOrganizacao.pontuacao_habilitacao"
                      label="Pontuação após análise"
                      disabled
                    />
          </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-textarea
                v-model="habilitacaoOrganizacao.ds_parecer"
                box
                label="* Parecer"
                name="input-7-4"
                rows="13"
                row-height="28"
                no-resize
                disabled
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import organizacaoUtils from '../utils/organizacaoUtils';

import File from '@/core/components/upload/File';

export default {
  name: 'OrganizacaoListaHabilitacaoDialog',
  components: {
    File,
  },
  data() {
    return {
      organizacaoUtils,
      habilitacaoOrganizacao: {
        organizacao:{
          arquivos:[]
        }
      },
      descricaoArquivos: {
        documento_identificacao_organizacao: 'Documento de identificação do representante legal responsável pela inscrição da organização ou entidade cultural (conforme item 2.8 do edital)',
        cpf_representante_organizacao: 'Documento de Cadastro de Pessoas Físicas (CPF) do representante legal responsável pela inscrição da organização ou entidade cultural',
        cnpj_organizacao: 'Comprovante do Cadastro Nacional da Pessoa Jurídica (CNPJ) que comprove a existência da entidade há pelo menos três anos',
        documento_constituicao_executiva_organizacao: 'Documento de constituição da atual diretoria e da presidência, ou cargo equivalente, da organização ou entidade cultural',
        documento_identificacao_executivo_organizacao: 'Documento de identificação (conforme item 2.8 do edital) do presidente, diretor executivo ou cargo equivalente',
        cpf_executivo_organizacao: 'Documento de Cadastro de Pessoas Físicas (CPF) do presidente, diretor executivo ou cargo equivalente',
        contrato_social_organizacao: 'Estatuto social ou contrato social atualizado, conforme o caso, devidamente registrado no órgão competente, de modo a comprovar o caráter cultural da entidade e seu ano de criação',
        relatorio_anual_atividade_organizacao: 'Relatório anual das atividades culturais dos últimos 06 (seis) anos (2016, 2017, 2018, 2019, 2020, 2021), com ações realizadas, no mínimo, em três anos, contendo, minimamente: o resumo de cada atividade, o local, o período de realização e o número de participantes',
        comprovativo_atividade_cultural_organizacao: 'Comprovação efetiva de que possui projetos ou atividades culturais realizados em ao menos 5 (cinco) estados de 2 (duas) macrorregiões brasileiras, a partir do exercício de 2016, por meio de: portfólio, folders, publicações, listas de presença, revistas, jornais, conteúdos de divulgação, links de vídeos, registros fotográficos ou outros materiais que permitam, minimamente, a identificação de data e local de realização das atividades e a aferição da veracidade das informações apresentadas. Anexar em único arquivo',
        lista_associados_atestada_organizacao: 'Lista de associados ou filiados atestada pelo dirigente da organização ou entidade cultural',
        comprovativo_atuacao_setor_cultural_organizacao: 'Documentação que comprove a atuação da organização ou entidade cultural em instâncias colegiadas do setor cultural, tais como organizacaos, comissões ou câmaras, se houver, por meio de termo de posse ou portaria de designação de representante',
        comprovativo_realizacao_projeto_cultural_organizacao: 'Documentação que comprove a realização de projetos na área de pesquisa ou produção do conhecimento no campo da cultura a partir de 2016, tais como: publicações, pesquisa de campo e artigos científicos',
      },
      certidoes: [
        {
          tp_arquivo: 'certidao_salic',
          label: 'Certidão SALIC',
        },
        {
          tp_arquivo: 'certidao_secult',
          label: 'Certidão SECULT',
        },
        {
          tp_arquivo: 'certidao_fgts',
          label: 'Situação FGTS',
        },
        {
          tp_arquivo: 'certidao_rf',
          label: 'Situação RF',
        },
        {
          tp_arquivo: 'certidao_tst',
          label: 'Situação TST',
        }
      ],
    };
  },
  filters: {
    somaPontuacao(criterios) {
      return criterios.map(c => parseInt(c.nu_nova_pontuacao)? parseInt(c.nu_nova_pontuacao):0).reduce((accumulator, value) => {
        return accumulator + value;
      }, 0);
    },
  },
  computed: {
    ...mapGetters({
      habilitacaoOrganizacaoGetter: 'organizacao/habilitacaoOrganizacao',
    }),
  },
  watch: {
    habilitacaoOrganizacaoGetter(value) {
      this.habilitacaoOrganizacao = value;
    },
  },
  methods: {
    ...mapActions({
      downloadArquivo: 'shared/downloadArquivo',
    }),
  },
  mounted() {
    this.habilitacaoOrganizacao = this.habilitacaoOrganizacaoGetter;
  },
};
</script>

